import React, { useEffect, useRef } from 'react'
import logoImage from '../img/logo.svg'
import { GiFloorPolisher, GiHamburgerMenu } from 'react-icons/gi'
import Nav from '../components/Nav'
import Body from '../components/Body'
import Section_1 from '../components/Section_1'
import Section_2 from '../components/Section_2'
import Section_3 from '../components/Section_3'
import Section_4 from '../components/Section_4'
import Section_5 from '../components/Section_5'
import Section_6 from '../components/Section_6'
import Section_7 from '../components/Section_7'
import Footer from '../components/Footer'
import Top from '../components/Top'


const Home = () => {
    useEffect(() => {
        const callback = function (entries) {
            entries.forEach((entry) => {
                console.log(entry);

                if (entry.isIntersecting) {
                    entry.target.classList.add("animate-fadeIn");
                } else {
                    entry.target.classList.remove("animate-fadeIn");
                }
            });
        };

        const observer = new IntersectionObserver(callback);

        const targets = document.querySelectorAll(".js-show-on-scroll");
        targets.forEach(function (target) {
            target.classList.add("opacity-0");
            observer.observe(target);
        });

    }, [])
    return (
        <div className='w-full'>
            {/* <Body/>  */}
            <Top />
            <Nav />
            <Section_1 />
            <Section_2 />
            <Section_3 />
            <Section_4 />
            <Section_5 />
            <Section_6 />
            <Section_7 />
            <Footer />
        </div>
    )
}

export default Home